// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-home-C":"C_power-ocean-home-C__4dPIn"};